const profileValidationEN = {
    "email": {
        "required": "The email address is required"
    },
    "profile_image": {
        "dimensions": "The profile image size has to be exactley 300 x 300 px, JPG/JPEG. Max file size 300 KB",
        "choose": "Please choose an image",
        "file": "The selected file is larger than 300 KB. Please uplaod cover in 300x300 px, JPG/JPEG, max file size 300 KB."
    },
    "street_and_number": {
        "required": "The street and house number is required"
    },
    "postal_code": {
        "required": "The postal code is required"
    },
    "city": {
        "required": "The city is required"
    },
    "country": {
        "required": "The country is required"
    },
    "vat_number": {
        "invalid": "The value is not a valid VAT number"
    },
    "iban": {
        "required": "IBAN is required",
        "invalid": "The value is not a valid IBAN number"
    },
    "cardholder_name": {
        "required": "Cardholder name is required"
    },
    "card_number": {
        "required": "Card Number is required",
        "invalid": "Card Number is not valid"
    },
    "card_year": {
        "required": "Expiry Year is required",
        "invalid": "Expiry Year is not valid"
    },
    "card_month": {
        "required": "Expiry Month is required"
    },
    "cvc_code": {
        "required": "Security Code (CVC) is required",
        "invalid": "Security Code (CVC) is not valid"
    },
    "paypal_email": {
        "required": "Paypal email is required",
        "invalid": "Paypal email is not valid"
    },
    "account_holder_name": {
        "required": "Bank account holder name is required"
    },
    "bank_name": {
        "required": "Bank name is required"
    },
    "bank_address": {
        "required": "Bank address is required"
    },
    "preferred_payment_method": {
        "required": "Preferred payment method is required"
    }
};

export default profileValidationEN;
